// Hamburger menu
let hamburger = document.querySelector('.hamburger');
let menu = document.querySelector('.list__btn');

function showMenu () {
  hamburger.classList.toggle('hamburger__active');
  menu.classList.toggle('list__btn--active');
}

// Copyright
let date = new currentDate();
document.querySelector('.footer__copyright p span').textContent = currentDate.getFullYear();

// WOW Animation
let wow = new WOW(
    {
      boxClass:     'wow',
      animateClass: 'animate__animated',
      mobile: false
    }
);
wow.init();

//Video youtube
function r(f) {
  /in/.test(document.readyState) ? setTimeout('r(' + f + ')', 9) : f()
}

r(function () {
  if (!document.getElementsByClassName) {
    // Поддержка IE8
    var getElementsByClassName = function (node, classname) {
      var a = [];
      var re = new RegExp('(^| )' + classname + '( |$)');
      var els = node.getElementsByTagName("*");
      for (var i = 0, j = els.length; i < j; i++)
        if (re.test(els[i].className)) a.push(els[i]);
      return a;
    }
    var videos = getElementsByClassName(document.body, "youtube");
  } else {
    var videos = document.getElementsByClassName("youtube");
  }

  var nb_videos = videos.length;
  for (var i = 0; i < nb_videos; i++) {
    // Находим постер для видео, зная ID нашего видео
    videos[i].style.backgroundImage = 'url(http://img.youtube.com/vi/' + videos[i].id + '/maxresdefault.jpg)';

    // Размещаем над постером кнопку Play, чтобы создать эффект плеера
    let play = document.querySelector('.about_brand__video--play');
    videos[i].appendChild(play);

    videos[i].onclick = function () {
      // Создаем iFrame и сразу начинаем проигрывать видео, т.е. атрибут autoplay у видео в значении 1
      var iframe = document.createElement("iframe");
      var iframe_url = "https://www.youtube.com/embed/" + this.id + "?autoplay=1&autohide=1";
      if (this.getAttribute("data-params")) iframe_url += '&' + this.getAttribute("data-params");
      iframe.setAttribute("src", iframe_url);
      iframe.setAttribute("class", 'youtube');
      iframe.setAttribute("frameborder", '0');
      iframe.setAttribute("allowfullscreen", '');
      iframe.setAttribute("allow", 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');

      // Заменяем начальное изображение (постер) на iFrame
      this.parentNode.replaceChild(iframe, this);
    }
  }
});

//Modal Video
let modalBlock = function (modal, btn) {
  if (modal) {
    btn.addEventListener('click', function () {
      const baseClass = modal.classList[0];
      const activeClass = `${baseClass}__active`;
      modal.classList.toggle(activeClass);
    });
  }
}

let modalVideo = document.querySelector('.modal_video'),
  modalOpen = document.querySelector('.video-play-button'),
  modalClose = document.querySelector('.close'),
  modalCloseX = document.querySelector('.close_x'),
  modalCloseBack = document.querySelector('.close_back');

modalBlock(modalVideo, modalOpen);
modalBlock(modalVideo, modalClose);
modalBlock(modalVideo, modalCloseX);
modalBlock(modalVideo, modalCloseBack);
